



























import Vue from 'vue';
import Component from 'vue-class-component';
import DxDraggable from 'devextreme-vue/draggable';
import EmailTable from '@/components/comment/email-table.vue';
import notify from 'devextreme/ui/notify';
import { FileUpload } from '@questelservices/common-vue';
import { QuestelServicesClient } from '@questelservices/common';

@Component({
  components: {
    DxDraggable,
    EmailTable,
    FileUpload
  }
})
export default class CommentsResponse extends Vue {
  public $refs: Vue['$refs'] & {
    parsedEmails?: EmailTable;
    unparsedEmails?: EmailTable;
    emailUpload?: FileUpload;
  } = {};

  private client = new QuestelServicesClient(this.$store, ''); 
  private toProcessFiles: File[] = [];   
  private notValidFiles: number = 0;

  private get emailUploader() {    
    return this.$refs.emailUpload as any;    
  }
   
  private onUploadComplete(args: { event: any; fileAuthResult: any; totalFiles: number }): void {    
    // Store files that are uploaded    
    if (args.fileAuthResult.Files[0]) {
      let fileExtension = args.fileAuthResult.Files[0].FileName.split('.').pop().toLowerCase();
      if(fileExtension === 'msg') {
        let file = args.fileAuthResult.Files[0];
        this.toProcessFiles.push(file);
      }
      else {
        this.notValidFiles++;
      }  
    }
    
    if (
      args.event.component.option('progress') === 100 
      && args.totalFiles === (this.notValidFiles + this.toProcessFiles.length)
    ) 
    {
      var files = this.toProcessFiles.map((x: any) => {
        return {
          FileId: x.FileId,
          Filename: x.FileName
        };
      });

      this.client
        .getPostData<{Success: boolean; Count: number}>('/api/FileParseUploads/comment-email', files)
        .then(data => {
                  
          if(data.Success) {                                    
            notify({message: `Successfully processed ${data.Count} file(s).`}, 'success', 2000);
            (this.$refs.parsedEmails as any).refreshDataGrid();
            (this.$refs.unparsedEmails as any).refreshDataGrid();
          } 
          else {          
            notify({message: `No file was processed. Only .msg files are accepted.`}, 'info', 2000);
          }         
        })
        .catch(response => {               
          notify({message: `Processing of file(s) has failed. ${response}`}, 'error', 2000);
        })
        .finally(() => {
          this.toProcessFiles = [];
          this.notValidFiles = 0;
          this.emailUploader.resetFileUploader();
        });        
    }    
  }
  
}
